/* Mats · Banner — animación de entrada al hacer scroll */
(function () {
  if (window.MatsBanner) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = !reduce && 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -5% 0px' })
    : null;

  function init(scope) {
    (scope || document).querySelectorAll('.mats-bn[data-mbn-reveal]').forEach(function (el) {
      if (el.dataset.mbnInit) return;
      el.dataset.mbnInit = '1';
      if (!io) return; // sin soporte o movimiento reducido: contenido visible tal cual
      el.classList.add('is-armed');
      // doble rAF para que el estado inicial se pinte antes de observar
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { io.observe(el); });
      });
    });
  }

  window.MatsBanner = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Editor de temas
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var bn = e.target.closest && e.target.closest('.mats-bn');
    if (bn) bn.classList.add('is-visible');
  });
})();
